import { store } from '../index';
import React from "react";
import { useState, useEffect, useMemo } from "react";
import { useActiveStoreCatalog } from "../store/selectors/menu";
import { connect, useSelector } from "react-redux";
import { Grid, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { useNavigate, useLocation } from "react-router-dom";
import { clearCart, removeItem } from "../store/actions/cartActions";
import ArrowBackIosNewTwoToneIcon from "@mui/icons-material/ArrowBackIosNewTwoTone";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import loading from "../assets/loading.gif";
import Navbar from "../components/Navbar";
import { get_tender, check_inventory_stock, update_local_storage_stock, remove_out_of_stock_from_cart } from "../utils/item_helper";
import { set_tender, order_place, set_customer, clear_last_order } from "../store/actions/action";
import { create_order, closeOrderViaSaveOrder, placeOrder, computeCheckoutTotals } from "../utils/order_helper";
import { BUTTON_COLOR, TOKEN_KEY, TEXT_COLOR } from "../utils/constant";
import { customer_order } from "../utils/customer_helper";
// import { displayRazorpay } from "../components/razorpay/Rezorpay";
// import { paytmPayment } from "../components/paytm/Paytm";
import { initiate_payment } from "../utils/payment_helper";

const CashIcon = ({ color }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.5947 14.1475H0.406628C0.295492 14.1475 0.193508 14.1931 0.12029 14.2673C0.045762 14.3415 0 14.4417 0 14.5524V29.5951C0 29.7057 0.045762 29.8073 0.12029 29.8802C0.194817 29.9544 0.295492 30 0.406628 30H29.5934C29.7045 30 29.8065 29.9544 29.8797 29.8802C29.9542 29.806 30 29.7057 30 29.5951V14.5524C30 14.4417 29.9542 14.3402 29.881 14.2673C29.8065 14.1931 29.7058 14.1475 29.5947 14.1475ZM22.0141 9.08493L11.727 13.1785H26.0387L24.8881 10.3114C24.3285 10.4273 23.7624 10.3608 23.259 10.1473C22.7556 9.93247 22.3161 9.56799 22.0141 9.08493ZM25.2057 4.8987L25.2201 4.89219C25.3194 4.85834 25.4253 4.86485 25.5169 4.90391C25.6123 4.94427 25.6934 5.02109 25.7339 5.12265L25.7352 5.12396H25.7339L28.966 13.1784H27.0806L25.6227 9.54585H25.6214C25.5221 9.29976 25.2423 9.17996 24.9938 9.27763C24.5401 9.45861 24.0538 9.43778 23.6367 9.2594C23.2274 9.08492 22.8836 8.75681 22.7005 8.31672C22.6979 8.30891 22.6953 8.3011 22.6927 8.29459C22.5933 8.0472 22.3109 7.92739 22.0625 8.02636L9.11304 13.1799H4.39558L25.2028 4.89877L25.2057 4.8987ZM9.41921 10.1419L14.0045 5.26569C14.483 5.57558 15.036 5.72142 15.5826 5.70318C16.1304 5.68495 16.673 5.50397 17.1306 5.16413L18.5649 6.50263L9.41921 10.1432V10.1419ZM17.0668 20.0167C17.595 20.5427 17.9219 21.2705 17.9219 22.0739C17.9219 22.8773 17.595 23.6052 17.0668 24.1312C16.5385 24.6572 15.8077 24.9827 15.0009 24.9827C14.1942 24.9827 13.4633 24.6572 12.9351 24.1312C12.4069 23.6051 12.08 22.8773 12.08 22.0739C12.08 21.2705 12.4069 20.5427 12.9351 20.0167C13.4633 19.4907 14.1942 19.1651 15.0009 19.1651C15.8077 19.1651 16.5385 19.4906 17.0668 20.0167ZM15.0009 18.1964C16.0757 18.1964 17.0485 18.63 17.7532 19.3318C18.4579 20.0336 18.8933 21.0023 18.8933 22.0726C18.8933 23.1429 18.4579 24.1116 17.7532 24.8135C17.0485 25.5153 16.0757 25.9488 15.0009 25.9488C13.9262 25.9488 12.9534 25.5152 12.2487 24.8135C11.5439 24.1116 11.1086 23.1429 11.1086 22.0726C11.1086 21.0023 11.544 20.0336 12.2487 19.3318C12.9534 18.63 13.9262 18.1964 15.0009 18.1964ZM26.5158 26.5295C26.1954 26.8485 25.998 27.2886 25.998 27.7743C25.998 28.0412 25.781 28.2587 25.5116 28.2587H4.48857C4.22053 28.2587 4.00219 28.0425 4.00219 27.7743C4.00219 27.2874 3.80477 26.8473 3.48443 26.5295C3.16409 26.2105 2.72218 26.0139 2.23447 26.0139C1.96644 26.0139 1.7481 25.7978 1.7481 25.5296V18.6171C1.7481 18.3502 1.96514 18.1327 2.23447 18.1327C2.72345 18.1327 3.16538 17.9361 3.48443 17.6171C3.80476 17.2981 4.00219 16.858 4.00219 16.3723C4.00219 16.1054 4.21924 15.888 4.48857 15.888H25.5116C25.7797 15.888 25.998 16.1041 25.998 16.3723C25.998 16.8593 26.1954 17.2994 26.5158 17.6171C26.8361 17.9361 27.278 18.1327 27.7657 18.1327V18.1353C28.0325 18.1353 28.2495 18.3515 28.2495 18.6171V25.4879C28.2508 25.5022 28.2521 25.5166 28.2521 25.5309C28.2521 25.7978 28.0351 26.0152 27.7657 26.0152C27.2768 26.0152 26.8348 26.2118 26.5158 26.5309L26.5158 26.5295ZM25.0697 27.2913H4.93196C4.83129 26.7314 4.55933 26.2314 4.17233 25.846C3.78533 25.4606 3.28326 25.1897 2.72104 25.0895V19.0583C3.28326 18.9581 3.78533 18.6872 4.17233 18.3018C4.55933 17.9165 4.83132 17.4165 4.93196 16.8566H25.0697C25.1704 17.4165 25.4423 17.9165 25.8293 18.3018C26.2163 18.6872 26.7197 18.9594 27.2833 19.0583V25.0895C26.7211 25.1898 26.2177 25.4606 25.8293 25.846C25.4423 26.2314 25.1704 26.7314 25.0697 27.2913ZM3.46491 12.5116L15.1106 0.126584C15.1865 0.0458558 15.2897 0.00419024 15.3943 0.000283671C15.5003 -0.00362257 15.6062 0.0328348 15.6885 0.108354L21.3552 5.39223L19.5575 6.10704L17.4694 4.16049C17.2746 3.9782 16.9686 3.98862 16.7869 4.18262C16.4535 4.53678 16.0063 4.72428 15.5526 4.73861C15.0989 4.75293 14.64 4.59669 14.2831 4.26336C14.0883 4.08107 13.7823 4.09149 13.6005 4.28549L7.30391 10.982L3.46641 12.5093L3.46491 12.5116Z"
      fill={color}
    />
  </svg>
);

const BHIMUPIIcon = ({ color = "#3159A6" }) => (
  <svg
    width="21"
    height="33"
    viewBox="0 0 21 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.06457 33L20.6753 17.0129C21.0094 16.7116 21.0953 16.2237 20.8881 15.8282L12.5942 0L11.187 4.87009C11.0358 5.395 11.3437 5.9439 11.8738 6.0936C12.4057 6.24331 12.9581 5.9402 13.1111 5.41345L13.1354 5.33213L18.7604 16.0669L6.64611 27.0618C6.53599 26.7846 6.30083 26.5591 5.98915 26.4722C5.45909 26.3207 4.90481 26.6257 4.75364 27.1506L3.06457 33ZM0 29.9005L15.0001 16.2829L7.87441 2.66528L0 29.9005Z"
      fill={color}
    />
  </svg>
);

const ArrowRight = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const getPaymentItemDetails = (tnd_type) => {
  const typeLower = tnd_type?.toLowerCase() || "";
  if (typeLower.includes("cash")) {
    return {
      label: "Cash",
      getIcon: (color) => <CashIcon color={color} />
    };
  } else if (typeLower.includes("upi") || typeLower.includes("qr") || typeLower.includes("online")) {
    return {
      label: "UPI",
      getIcon: (color) => <BHIMUPIIcon color={color} />
    };
  } else {
    return {
      label: tnd_type,
      getIcon: (color) => <CashIcon color={color} />
    };
  }
};


function Checkout(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const isFSROrder = location.state?.isFSROrder;
  const fsrActiveOrder = location.state?.activeOrder;
  const fsrRecalculatedTotals = location.state?.recalculatedTotals;

  const { cartProps, reducer, customerReducer } = props;
  const { items: catalogItems } = useActiveStoreCatalog();
  const reduxSessionReducer = useSelector(state => state.sessionReducer);
  const sessionReducer = props.sessionReducer || reduxSessionReducer || {};
  const storeInfo = sessionReducer?.store_details || null;
  const storeInfoConfig = sessionReducer?.store_config || null;

  const user = reducer?.user || null;
  const storeDetails = storeInfo;   // restaurant store info (not Redux store)

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        console.warn("[bfcache] Checkout restored from back-forward cache → staying on /checkout");
        setBtnDisable(false);
        setConfirm(false);
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  const getTableNumber = () => {
    let fsrObject = sessionReducer.table_details || {};
    if (sessionReducer.is_fsr === true) {
      if (fsrObject?.qr_table_id) return fsrObject.qr_table_id;
      const fullTableId = (fsrObject?.floor_name || "") + (fsrObject?.table_name || "");
      if (fullTableId) return fullTableId;
      if (fsrObject?.floor_no && fsrObject?.table_no) return `F${fsrObject.floor_no}T${fsrObject.table_name}`;
      return (fsrObject?.table_no || "").replace(/^table_|^tent_/i, "");
    }
    const tent = sessionReducer.table_details?.table_no || sessionReducer.tent_id || "";
    const locId = sessionReducer.location_id || user?.location_id || "";
    const rawTable = tent || locId || "";
    return String(rawTable).replace(/^table_|^tent_/i, "");
  };

  const getAllPossibleTableIds = (order) => {
    const ids = [];
    if (order?.table_no) ids.push(String(order.table_no).replace(/^table_|^tent_/i, ""));
    if (order?.store_details?.table_no) ids.push(String(order.store_details.table_no).replace(/^table_|^tent_/i, ""));
    if (order?.store_details?.floor_no && order?.store_details?.table_no) {
      ids.push(`F${order.store_details.floor_no}T${order.store_details.table_no}`);
    }
    if (order?.floor_no && order?.table_no) {
      ids.push(`F${order.floor_no}T${order.table_no}`);
    }
    const currentTableNo = getTableNumber();
    if (currentTableNo) ids.push(currentTableNo);

    return [...new Set(ids)]; // Unique IDs
  };

  const { store_id } = user || {};
  const [paymentOption, setPaymentOption] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [tender, setTender] = useState([]);
  const [isReload, setIsReload] = useState(true);
  const [btnDisable, setBtnDisable] = useState(false);
  const [open, setOpen] = useState(false);
  const [createdOrderRes, setCreatedOrderRes] = useState(null);
  const [openOutOfStock, setOpenOutOfStock] = useState(false);
  const [outOfStockItems, setOutOfStockItems] = useState([]);

  let primaryColor = storeInfoConfig?.general_config?.primary_color;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  const StoreCharge = storeInfoConfig?.general_config?.store_charges || reducer?.storeCharges || null;
  const storeCharges = StoreCharge ? JSON.stringify(StoreCharge) : null;
  let type = cartProps?.orderType?.order?.order_type || "Takeaway";
  const orderCode = cartProps?.orderType?.order?.order_code || cartProps?.orderType?.order?.channel_code;
  const isDelivery = orderCode === "DEL" || orderCode === "del" || type?.toLowerCase() === "delivery";
  let offer = cartProps?.appliedOffer || null;

  useEffect(() => {
    if (!isDelivery) {
      let CustomerData = props.customerReducer?.customer;
      if (CustomerData?.cust_address) {
        CustomerData = { ...CustomerData, cust_address: "NA" };
        props?.set_customer(CustomerData);
      }
    }
  }, []);

  const totals = useMemo(() => {
    const items = isFSROrder
      ? (fsrActiveOrder?.item_details || [])
      : (cartProps?.addedItems || []);
    // applyCurrentOffer:true → helper folds any applied offer + current tip
    // into transaction_grand_amount. No manual engineDiscount merge needed.
    return computeCheckoutTotals(items, {
      orderType:         cartProps?.orderType?.order?.order_type,
      storeId:           storeInfo?.store_id,
      paymentOption,
      storeConfig:       storeInfoConfig,
      itemsAreFlat:      isFSROrder,
      tip:               cartProps?.tip || 0,
      applyCurrentOffer: true,
    });
  }, [isFSROrder, fsrActiveOrder, cartProps?.addedItems, cartProps?.tip, cartProps?.orderType, paymentOption, storeInfoConfig, storeInfo?.store_id, cartProps?.engineDiscount]);

  const onloadData = async () => {
    const [storeTender] = await Promise.all([get_tender()]);
    setTender(storeTender);
    setIsReload(false);
  };

  const loadPaytmScript = async () => {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://${storeDetails?.gateway?.host}/merchantpgpui/checkoutjs/merchants/${storeDetails?.gateway?.mid}.js`;
    script.onload = function () {
      console.log("checkout script loaded");
    };
    script.onerror = function () {
      navigate("/payment-fail");
    };
    document.body.appendChild(script);
  };

  useEffect(() => {
    if (storeDetails?.gateway?.type === "paytm") {
      loadPaytmScript();
    }
    if (isReload) {
      onloadData();
    }
  }, [isReload]);

  useEffect(() => {
    const handlePageShow = () => {
      setBtnDisable(false);
      setConfirm(false);
    };

    window.addEventListener("pageshow", handlePageShow);
    window.addEventListener("focus", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
      window.removeEventListener("focus", handlePageShow);
    };
  }, []);

  const handleChange = (tendr) => {
    setPaymentOption(tendr);
    setConfirm(false);
    props.set_tender(tendr);
  };

  const sendOrderMssg = async (orderDet) => {
    try {
      // let orderDet = JSON.parse(orderDetails);
      const order = await customer_order({
        order_id: orderDet?._id,
        store_id: orderDet?.store_details?.store_id,
        to_phone_number: "91" + orderDet?.customer_details[0].cust_mobile,
      });
      console.log(order);
      // setSentOtp(true);
      return order;
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  // updateOrderStatus: handles gateway callbacks (Razorpay/Paytm).
  // Always closes orders via save-order (unified endpoint).
  const updateOrderStatus = async (paymentResp, order_status) => {
    const { paymentResponse, orders } = paymentResp;

    // FSR: placeOrder handles the full close flow
    if (isFSROrder) {
      const resp = await placeOrder({
        flow: "FSR_PAY_BILL",
        paymentResp,
        orderStatus: "CLOSE",
        paymentOption,
        activeOrder: fsrActiveOrder,
        recalculatedTotals: fsrRecalculatedTotals
      });
      if (resp?.status) navigate("/order-status");
      else { alert("Something went wrong!"); setBtnDisable(false); }
      return resp;
    }

    // QSR — no pre-created order: create it first
    if (!orders || orders.length === 0) {
      const resp = await placeOrder({
        flow: "QSR_CHECKOUT",
        paymentResp: paymentResponse,
        orderStatus: order_status,
        paymentOption
      });
      if (resp?.status) { navigate("/order-status"); setBtnDisable(false); }
      else { alert("Something went wrong while saving the order!"); setBtnDisable(false); }
      return resp;
    }

    // QSR — order exists: close it via save-order with payment_details attached
    const existingOrder = Array.isArray(orders) ? orders[0] : orders;
    const resp = await closeOrderViaSaveOrder({
      order:         existingOrder,
      transResponse: paymentResponse,
      orderStatus:   order_status,
    });
    if (!resp?.status) {
      alert("Something went wrong!");
    } else {
      let orderData = resp.data;
      if (orderData) {
        if (!Array.isArray(orderData)) {
          orderData = orderData.master ? [orderData.master] : [orderData];
        }
        props.order_place(orderData);
      }
      navigate("/order-status");
      setBtnDisable(false);
    }
    return resp;
  };

  const handleConfirmButton = async () => {
    // Inventory check is only for new orders, bypass for FSR running order paybill
    if (!isFSROrder) {
      try {
        const response = await check_inventory_stock({ items: cartProps?.addedItems || [] });
        if (response && response.status === false) {
          update_local_storage_stock(response.out_of_stock_items || [], catalogItems, props.update_item_list);
          setOutOfStockItems(response.out_of_stock_items || []);
          setOpenOutOfStock(true);
          return; // Block order confirmation
        }
      } catch (error) {
        console.error("Error checking inventory stock:", error);
      }
    }

    const customer = props.customerReducer?.customer || {};
    setConfirm(false);
    setBtnDisable(false);
    if (paymentOption) {
      setBtnDisable(true);
    } else if (!paymentOption) {
      setOpen(true);
    }

    if (paymentOption?.tnd_code !== "QR" && paymentOption) {
      const order_status = paymentOption?.tnd_code == "PL" ? "OPEN" : "CLOSE";

      const resp = isFSROrder
        ? await placeOrder({
            flow: "FSR_PAY_BILL",
            paymentResp: {},
            orderStatus: order_status,
            paymentOption,
            activeOrder: fsrActiveOrder,
            recalculatedTotals: fsrRecalculatedTotals
          })
        : await placeOrder({
            flow: "QSR_CHECKOUT",
            paymentResp: {},
            orderStatus: order_status,
            paymentOption
          });

      if (!resp?.status) {
        alert("Something went wrong while placing the order!");
        setBtnDisable(false);
        return;
      }

      if (isFSROrder) {
        navigate("/order-status");
        return;
      }

      // Cash / Pay Later: placeOrder already saved the order (CLOSE for cash,
      // OPEN for pay-later) with payment_details attached.
      // A second save-order via updateOrderStatus would be a duplicate.
      if (paymentOption?.tnd_code === "CA" || paymentOption?.tnd_code === "PL") {
        let orderData = resp.data;
        if (orderData) {
          if (!Array.isArray(orderData)) {
            orderData = orderData.master ? [orderData.master] : [orderData];
          }
          props.order_place(orderData);
        }
        props.order_place(orderData);
      }
      navigate("/order-status");
      setBtnDisable(false);
    } else {
      setConfirm(true);
      setBtnDisable(true);
      try {
        if (paymentOption) {
          const resp = await initiate_payment();
          const redirectUrl =
            resp?.data?.redirect_url ||
            resp?.redirect_url ||
            resp?.data?.instrumentResponse?.redirectInfo?.url;
          if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
          }
          alert("Something went wrong while initiating payment!");
        }
      } catch (err) {
        console.error("[Checkout] Payment initiation failed", err);
      } finally {
        setBtnDisable(false);
        setConfirm(false);
      }
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const getRoundedTotal = (rawOverride) => {
    const roundOffSetting = storeInfoConfig?.general_config?.round_off;
    const roundOffType = (storeInfoConfig?.general_config?.type || storeInfoConfig?.general_config?.round_off_type || "nearest").toLowerCase();

    let isRoundOffApplicable = false;

    if (isFSROrder) {
      // FSR: apply rounding only for the payment types specified in config
      const configApplyFor = (storeInfoConfig?.general_config?.apply_for || "").toLowerCase();
      const configPaymentTypes = storeInfoConfig?.general_config?.payment_types || storeInfoConfig?.general_config?.round_off_payments;

      const currentTnd = paymentOption;
      const currentTndType = (currentTnd?.tnd_type || "").toLowerCase();
      const currentTndCode = (currentTnd?.tnd_code || "").toLowerCase();

      if (roundOffSetting === true || roundOffSetting === "true") {
        if (configApplyFor.includes("cash only")) {
          isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
        } else if (configApplyFor.includes("selected payments") || Array.isArray(configPaymentTypes)) {
          if (Array.isArray(configPaymentTypes)) {
            isRoundOffApplicable = configPaymentTypes.some(item => {
              if (typeof item === "string") {
                const itemLower = item.toLowerCase();
                return currentTndType === itemLower || currentTndCode === itemLower || currentTndType.includes(itemLower);
              }
              if (typeof item === "object" && item) {
                const itemType = (item.tnd_type || item.type || "").toLowerCase();
                const itemCode = (item.tnd_code || item.code || "").toLowerCase();
                return currentTndType === itemType || currentTndCode === itemCode || (itemType && currentTndType.includes(itemType));
              }
              return false;
            });
          } else {
            isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
          }
        } else {
          isRoundOffApplicable = true;
        }
      }
    } else {
      // QSR: simple round_off flag — apply rounding if enabled, regardless of payment method
      isRoundOffApplicable = roundOffSetting === true || roundOffSetting === "true";
    }

    const rawTotal = rawOverride != null
      ? rawOverride
      : (isFSROrder
          ? (fsrRecalculatedTotals?.unroundedTotal ?? fsrRecalculatedTotals?.total ?? fsrActiveOrder?.total ?? 0)
          : ((cartProps?.total || 0) + (cartProps?.total_tax || 0) + (cartProps?.tip || 0)));

    let roundedTotal = rawTotal;

    if (isRoundOffApplicable) {
      if (roundOffType === "up") {
        roundedTotal = Math.ceil(rawTotal);
      } else if (roundOffType === "down") {
        roundedTotal = Math.floor(rawTotal);
      } else {
        roundedTotal = Math.round(rawTotal);
      }
    }
    return roundedTotal;
  };

  const getCurrencySymbol = () => {
    let storeCurrency = storeInfo?.store_currency;
    switch (storeCurrency) {
      case "INR": return "₹";
      case "USD": return "$";
      case "CAD": return "$";
      case "OMR": return "OMR ";
      case "AED": return "AED ";
      default: return "$";
    }
  };

  return (
    <>
      <Grid
        container
        style={{
          display: btnDisable ? "flex" : "none",
          flexDirection: "column",
          position: "absolute",
          height: "100%",
          alignContent: "center",
        }}
        justifyContent="center"
      >
        <img style={{ height: "10%" }} src={loading} alt="logo" />
        <Typography>Loading</Typography>
      </Grid>

      <Grid
        style={{ height: "100vh", filter: btnDisable ? "blur(5px)" : "none" }}
      >
        <Navbar cartPage />
        <Grid
          container
          justifyContent="left"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            paddingTop: "1.5rem",
            margin: "0px",
            padding: "16px 10px",
            dispaly: "flex",
            alignItems: "center",
            backgroundColor: "white",
            borderRadius: "0px",
            boxShadow: "rgba(0, 0, 0, 0.08) 0px 2px 12px",
            position: "relative",
          }}
        >
          <ArrowBackIosNewTwoToneIcon
            onClick={() => {
              if (isFSROrder) {
                navigate("/cart", { state: { fsrView: "orders", activeTab: "pay" } });
              } else {
                navigate("/cart");
              }
            }}
            style={{
              position: "absolute",
              marginTop: "0.3rem",
              marginLeft: "0.3rem",
              left: 10,
            }}
          />
          <Typography
            variant="h5"
            style={{ fontWeight: "bold", marginLeft: "3.5rem" }}
          >
            Payment
          </Typography>
        </Grid>
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ padding: "1rem" }}
        >
          <Grid style={{ width: "100%" }}>
            <Typography
              fullWidth
              style={{ marginLeft: "1rem", fontWeight: "bold" }}
              variant="h6"
            >
              Payment Method
            </Typography>
          </Grid>

          {!isReload ? (
            <div style={{ width: "100%", padding: "1rem" }}>
              {tender?.map((value) => {
                const isSelected = paymentOption?.tnd_type === value.tnd_type;
                const details = getPaymentItemDetails(value.tnd_type);
                const activeColor = primaryColor || BUTTON_COLOR;
                
                return (
                  <div
                    key={value.tnd_type}
                    onClick={() => !btnDisable && handleChange(value)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "16px 20px",
                      borderRadius: "8px",
                      cursor: btnDisable ? "not-allowed" : "pointer",
                      transition: "all 0.2s ease-in-out",
                      width: "100%",
                      boxSizing: "border-box",
                      border: `1.5px solid ${activeColor}`,
                      backgroundColor: isSelected ? activeColor : "white",
                      color: isSelected ? "white" : "#2D3748",
                      opacity: btnDisable ? 0.7 : 1,
                      marginBottom: "16px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                      {details.getIcon(isSelected ? "white" : activeColor)}
                      <span style={{ fontSize: "16px", fontWeight: "600", fontFamily: "Satoshi" }}>
                        {details.label}
                      </span>
                    </div>
                    <ArrowRight color={isSelected ? "white" : activeColor} />
                  </div>
                );
              })}
            </div>
          ) : (
            <Grid className="loadingreport" style={{ paddingTop: "10rem", width: "100%", textAlign: "center" }}>
              <CircularProgress variant="indeterminate" />
              <p>Loading </p>
            </Grid>
          )}
          <Snackbar
            style={{ marginBottom: "5rem" }}
            open={open}
            autoHideDuration={1000}
            onClose={handleClose}
            message="Please select a payment method"
            action={action}
            ContentProps={{
              sx: {
                backgroundColor: 'var(--primary-color, #333)',
                color: 'var(--secondary-color, #fff)',
                fontFamily: 'Satoshi',
                borderRadius: '8px',
                zIndex: 1000,
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
              }
            }}
          />

          <div className="PaymentBtn">
            <Button
              variant="contained"
              disabled={btnDisable}
              onClick={() => handleConfirmButton()}
              style={{
                fontSize: "1.3rem",
                borderRadius: "8px",
                minWidth: "100%",

                // padding: "0.5rem",
                fontWeight: "Bold",
                lineHeight1: "1.5",

                color:  "white"  || TEXT_COLOR,
                backgroundColor: primaryColor || BUTTON_COLOR,
              }}
            >
              {paymentOption
                ? `Continue with amount ${getCurrencySymbol()} ${parseFloat(getRoundedTotal(totals?.transaction_grand_amount)).toFixed(2)}`
                : "Continue"}
            </Button>
          </div>
        </Grid>
      </Grid>
      <Dialog
        open={openOutOfStock}
        onClose={() => {
          setOpenOutOfStock(false);
          navigate("/menu");
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "20px",
            padding: "20px",
            backgroundColor: "#fff",
          },
        }}
      >
        <DialogTitle
          style={{
            padding: "0px",
            marginBottom: "10px",
          }}
        >
          <Typography
            style={{
              fontFamily: "Plus Jakarta Sans",
              color: primaryColor || "#000",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            <span style={{ fontSize: "20px" }}>Out of Stock</span>
          </Typography>
        </DialogTitle>

        <DialogContent style={{ padding: "0px", marginBottom: "20px" }}>
          <Typography
            style={{
              fontFamily: "Satoshi",
              fontSize: "14px",
              color: "#333333",
              textAlign: "left",
              fontWeight: "500",
            }}
          >
            Some items or addons in your cart are currently out of stock. We cannot process your order.
          </Typography>
          <div style={{ maxHeight: "200px", overflowY: "auto", marginTop: "15px", border: "1px solid #EDF2F7", borderRadius: "8px" }}>
            {outOfStockItems?.map((item, idx) => (
              <div
                key={idx}
                style={{
                  padding: "10px 14px",
                  borderBottom: idx === outOfStockItems.length - 1 ? "none" : "1px solid #EDF2F7",
                  fontSize: "14px",
                  color: "#2D3748",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontFamily: "Satoshi"
                }}
              >
                <span style={{ fontWeight: "600" }}>{item.item_name}</span>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#718096",
                    backgroundColor: "#EDF2F7",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    textTransform: "capitalize"
                  }}
                >
                  {item.type}
                </span>
              </div>
            ))}
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "0px", justifyContent: "center" }}>
          <Button
            onClick={() => {
              remove_out_of_stock_from_cart(outOfStockItems, cartProps?.addedItems, props.removeItem, props.clearCart);
              setOpenOutOfStock(false);
              navigate("/menu", { state: { skipAutoRedirect: true } });
            }}
            variant="contained"
            disableElevation
            style={{
              flex: "1",
              borderRadius: "8px",
              fontSize: "14px",
              color: "white",
              backgroundColor: primaryColor || BUTTON_COLOR,
              textTransform: "none",
              fontWeight: "700",
              padding: "8px",
              boxShadow: "none",
            }}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer || {},
    customerReducer: state.customerReducer || {},
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    set_tender: (obj) => {
      dispatch(set_tender(obj));
    },
    set_customer: (obj) => {
      dispatch(set_customer(obj));
    },
    order_place: (obj) => {
      dispatch(order_place(obj));
    },
    update_item_list: (items) => {
      dispatch({ type: "ITEM_LIST", item_list: items });
    },
    clearCart: () => {
      dispatch(clearCart());
    },
    removeItem: (item) => {
      dispatch(removeItem(item));
    },
    clear_last_order: () => {
      dispatch(clear_last_order());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
